export default function ComparisonTable() {
  const rows = [
    { feature: 'Facilità utilizzo', itaobuy: '★★★★★', excel: '★★★★', sheets: '★★★★' },
    { feature: 'Collaborazione', itaobuy: 'Alta', excel: 'Media', sheets: 'Alta' },
    { feature: 'Automazione', itaobuy: 'Avanzata', excel: 'Avanzata', sheets: 'Media' },
    { feature: 'Utilizzo online', itaobuy: 'Sì', excel: 'Limitato', sheets: 'Sì' },
    { feature: 'Curva apprendimento', itaobuy: 'Bassa', excel: 'Media', sheets: 'Bassa' },
    { feature: 'Template pronti', itaobuy: 'Sì', excel: 'Sì', sheets: 'Limitati' },
    { feature: 'Supporto dedicato', itaobuy: '24/7', excel: 'Community', sheets: 'Community' },
  ];

  return (
    <section className="w-full bg-background-50 py-20 md:py-28">
      <div className="max-w-4xl mx-auto px-4 md:px-6 lg:px-10">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-foreground-950 font-heading">
            Itaobuy Spreadsheet vs{' '}
            <span className="italic font-normal">Alternative</span>
          </h2>
          <p className="mt-3 text-base text-foreground-600 font-body">
            Confronta le caratteristiche principali e scopri perché itaobuy sheet è la scelta migliore.
          </p>
        </div>

        <div className="overflow-x-auto rounded-2xl border border-background-200/70">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-background-200/70 bg-background-100">
                <th className="text-left py-4 px-6 font-semibold text-foreground-800 font-label">
                  Caratteristica
                </th>
                <th className="text-center py-4 px-6 font-semibold text-primary-600 font-label">
                  Itaobuy Spreadsheet
                </th>
                <th className="text-center py-4 px-6 font-semibold text-foreground-600 font-label">
                  Excel
                </th>
                <th className="text-center py-4 px-6 font-semibold text-foreground-600 font-label">
                  Google Sheets
                </th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row, idx) => (
                <tr
                  key={row.feature}
                  className={`border-b border-background-200/40 ${
                    idx % 2 === 0 ? 'bg-background-50' : 'bg-background-100/50'
                  }`}
                >
                  <td className="py-3.5 px-6 text-foreground-700 font-body">{row.feature}</td>
                  <td className="py-3.5 px-6 text-center text-primary-600 font-semibold font-label">
                    {row.itaobuy}
                  </td>
                  <td className="py-3.5 px-6 text-center text-foreground-600 font-body">
                    {row.excel}
                  </td>
                  <td className="py-3.5 px-6 text-center text-foreground-600 font-body">
                    {row.sheets}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="mt-8 text-center">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap font-label"
          >
            Prova Itaobuy Sheet
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}